export type CartItemTaxDetailsInput = {
  tax_rate?: number;
  tax_amount?: number;
  applied_state?: string;
};

/** Default cart line tax block; `taxable` mirrors product `is_taxable` from inventory. */
export function buildCartItemTaxInfo(
  taxDetails: CartItemTaxDetailsInput,
  isTaxable?: boolean
) {
  const tax_rate = Number(taxDetails.tax_rate ?? 0);
  const tax_amount = Number(taxDetails.tax_amount ?? 0);
  const applied_state = String(taxDetails.applied_state ?? "");
  const taxable = typeof isTaxable === "boolean" ? isTaxable : true;

  return {
    tax_percentage: tax_rate,
    unit_product_tax_amount: 0,
    total_product_tax_amount: tax_amount,
    tax_details: {
      tax_rate,
      tax_amount,
      applied_state,
    },
    taxable,
  };
}
